import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertMessageModule, HubLogoModule, HubNavModule, ModalModule, SimpleModalModule, SvgIconModule, TrAccordionModule } from '@toro/common/shared/components';
import { TooltipDirectiveModule, TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives';

import { CardHeaderComponent } from './cards/card-header/card-header.component';
import { CardLoadingComponent } from './cards/card-loading/card-loading.component';
import { CommonModule } from '@angular/common';
import { DateISOStringPipeModule } from '@toro/common/shared/pipes';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GlobalModule } from './../global.module';
import { HubChipComponent } from './hub-chip/hub-chip.component';
import { HubDraggableComponent } from './hub-draggable/hub-draggable.component';
import { HubHistoryComponent } from './hub-history/hub-history.component';
import { HubLiveSectionComponent } from './hub-live-section/hub-live-section.component';
import { HubSearchComponent } from './hub-search/hub-search.component';
import { LiveVideoComponent } from './live-video/live-video.component';
import { MarketCardComponent } from './cards/market-card/market-card.component';
import { MatDialogRef } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { OpportunityCardComponent } from './cards/opportunity-cards/opportunity-card/opportunity-card.component';
import { PlanedCardComponent } from './cards/planned-card/planned-card.component';
import { RouterModule } from '@angular/router';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { StockPipesModule } from '../pipes/stock-pipes.module';
import { StockResultsComponent } from './cards/stock-results/stock-results.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { UnplanedCardComponent } from './cards/unplanned-card/unplanned-card.component';
import { StructuredProductCardComponent } from './cards/structured-product-card/structured-product-card.component';
import { CardWarningComponent } from './cards/card-warning/card-warning.component';
import { GroupedCardComponent } from './cards/grouped-card/grouped-card.component';
import { VimeoPopVideoComponent } from './vimeo-pop-video/vimeo-pop-video.component';
import { RankTraderComponent } from './stamps/rank-trader/rank-trader.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { TimeInCategoryComponent } from './stamps/time-in-category/time-in-category.component';
import { CardTraderComponent } from './cards/card-trader/card-trader.component';

const COMPONENTS = [
    HubSearchComponent,
    HubChipComponent,
    SkeletonComponent,
    HubHistoryComponent,
    LiveVideoComponent,
    HubLiveSectionComponent,
    HubDraggableComponent,
    VimeoPopVideoComponent,
    CardHeaderComponent,
    CardLoadingComponent,
    OpportunityCardComponent,
    MarketCardComponent,
    PlanedCardComponent,
    StockResultsComponent,
    UnplanedCardComponent,
    StructuredProductCardComponent,
    CardWarningComponent,
    GroupedCardComponent,
    RankTraderComponent,
    ProgressBarComponent,
    TimeInCategoryComponent,
    CardTraderComponent,
];

@NgModule({
    imports: [
        GlobalModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        TrSpinnerButtonDirectiveModule,
        TooltipDirectiveModule,
        HubNavModule,
        HubLogoModule,
        SimpleModalModule,
        ModalModule,
        SvgIconModule,
        DateISOStringPipeModule,
        TrAccordionModule,
        DragDropModule,
        StockPipesModule,
        TypeaheadModule.forRoot(),
        AlertMessageModule,
    ],
    declarations: COMPONENTS,
    exports: COMPONENTS,
    providers: [
        {provide: MatDialogRef, useValue: {}},
    ],
})
export class ComponentsModule { }
